export default {
    data () {
        return {
            streams: [],
            filters: {
                landings: [],
                deviceTypes: [],
                countries: [],
                offers: []
            }
        };
    },
    created () {
        this.$axios.get('/streams', this.model).then((res) => {
            this.streams = res.data;
        });

        this.$axios.get('/stat/filters', this.model).then((res) => {
            this.filters = res.data;
        });
    },
    computed: {
        landings() {
            let offerIDs=this.model.offerIDs;

            if (!offerIDs.length) {
                return this.filters.landings;
            }

            return this.filters.landings.filter(function(item) {
                return offerIDs.filter((function(value){ return value === item.offer_id; })).length;
            });
        }
    },
}